import React, { useState } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import core from "../../vendors/core-api";
import { Bargraph } from "../widgets/Bargraph";
import useFetch from "../../hooks/useFetch";
import {
  toPesoAmount,
  stackedBarGraphProps,
  getStatusDisplay,
} from "../../helpers";
import PacmanWrapper from "./PacmanWrapper";
import { DB_DATE_FORMAT } from "../../constants";

const SalesByFulfillmentCard = (props) => {
  const [modalData, setModalData] = useState(null);
  const { params = {}, excludeDeliveryFee, setExcludeDeliveryFee } = props;
  const { dateRange = "day" } = params;
  const api = core("pu").get();
  const columnWidth = ["month", "year", "between"].includes(dateRange)
    ? "65%"
    : "80%";
  const dateRangeValues = [
    "day",
    "week",
    "month",
    "year",
    "allTime",
    "yesterday",
    "between",
  ];
  const dateRangeSuffixed = [
    "Daily",
    "Weekly",
    "Monthly",
    "Yearly",
    "All-time",
    "Yesterday",
    "Custom Range",
  ];

  const reqObj = {
    url: "/dashboard/sales-by-fulfillment",
    method: "post",
    body: { ...params, excludeDeliveryFee },
  };

  const dataFormatter = {
    dataFormatter: stackedBarGraphProps,
    args: [params.dateRange],
  };

  const { data, isLoading } = useFetch(reqObj, dataFormatter, [
    excludeDeliveryFee,
  ]);

  const handleDataPointClick = async (
    event,
    chartContext,
    { seriesIndex, dataPointIndex },
  ) => {
    if (!data) return;

    const order_date = data.rawCategories[dataPointIndex];

    const body = {
      ...params,
      getOrderDetails: true,
      clickedDate: order_date,
      excludeDeliveryFee,
    };
    const ordersReq = {
      url: "/dashboard/sales-by-fulfillment",
      data: body,
    };

    setModalData({
      isLoading: true,
      date: moment(order_date, DB_DATE_FORMAT).format("MMM DD, YYYY"),
    });
    const orderData = await api.post(ordersReq);

    setModalData({
      ...orderData.data,
      date: moment(order_date, DB_DATE_FORMAT).format("MMM DD, YYYY"),
      isLoading: false,
    });
  };

  const handleGenerateReport = () => {
    if (!data) return;

    const filteredSeries = data.series.filter(
      (s) => s.data.reduce((a, b) => a + (b || 0), 0) > 0,
    );

    const headers = ["Date", ...filteredSeries.map((s) => s.name), "Total"];

    const rows = data.categories.map((category, index) => {
      const rowData = filteredSeries.map((series) => series.data[index]);
      const total = rowData.reduce((sum, val) => sum + val, 0);
      return [category, ...rowData, total];
    });

    let csvContent = "data:text/csv;charset=utf-8,";
    csvContent += headers.join(",") + "\n";

    rows.forEach((rowArray) => {
      let row = rowArray.join(",");
      csvContent += row + "\n";
    });

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute(
      "download",
      `sales-by-fulfillment-${params.dateRange}.csv`,
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <OrdersModal
        show={!!modalData}
        onHide={() => setModalData(null)}
        data={modalData}
      />
      {isLoading || data === null ? (
        <PacmanWrapper />
      ) : (
        <Bargraph
          className={"sales-by-fulfillment h-100 m-0 overflow-hidden"}
          series={data.series.filter(
            (s) => s.data.reduce((a, b) => a + (b || 0), 0) > 0,
          )}
          categories={data.categories}
          height={250}
          customOptions={{
            chart: {
              type: "bar",
              stacked: false,

              events: {
                dataPointSelection: handleDataPointClick,
              },
              toolbar: {
                show: false,
              },
              height: "100%",
            },
            responsive: [
              {
                options: {
                  legend: {
                    position: "bottom",
                  },
                },
              },
            ],
            plotOptions: {
              bar: {
                columnWidth: columnWidth,
                startingShape: "rounded",
                endingShape: "rounded",
              },
            },
            grid: {
              xaxis: {
                lines: {
                  show: false,
                },
              },
              yaxis: {
                lines: {
                  show: false,
                },
              },
            },
            dataLabels: {
              enabled: false,
            },
            legend: {
              position: "left",
            },
            yaxis: {
              type: "category",
              labels: {
                show: false,
              },
              axisTicks: {
                show: false,
              },
            },
            colors: ["#50b585", "#795ecc", "#f54962", "#FFA800", "#73b54f"],
            tooltip: {
              y: {
                formatter: function (
                  value,
                  { series, seriesIndex, dataPointIndex, w },
                ) {
                  return toPesoAmount(value);
                },
              },
              custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                return `
                                <div class="barContainer">
                                    <h5 class="barHeader">${
                                      w.globals.labels[dataPointIndex]
                                    }</h5>

                                    <div class="barContent">
                                        ${w.globals.seriesNames.reduce(
                                          (acc, cur, i) => {
                                            return `${acc}  <div class="barSeriesContent">
                                                <span class="barBadge" style="background-color: ${
                                                  w.globals.colors[i]
                                                }"></span>
                                                <span>${cur}</span>
                                                <span class='barData'>${toPesoAmount(
                                                  series[i][dataPointIndex],
                                                )}</span>
                                            </div>`;
                                          },
                                          "",
                                        )}


                                        <div class="barSeriesContent bold">
                                            <span>Total</span>
                                            <span class='barData'>${toPesoAmount(
                                              series.reduce(
                                                (acc, cur) =>
                                                  acc + cur[dataPointIndex],
                                                0,
                                              ),
                                            )}</span>
                                        </div>
                                    </div>
                                </div>
                            `;
              },
            },
            stroke: {
              show: true,
              width: 1,
              colors: ["#fff"],
            },
          }}
        >
          <div className="d-flex justify-content-between align-items-center pt-8 px-8">
            <div className="d-flex align-items-center">
              <h4 className="m-0">
                {
                  dateRangeSuffixed[
                    dateRangeValues.indexOf(
                      dateRange === "day" ? "week" : dateRange,
                    )
                  ]
                }{" "}
                Sales by Fulfillment
              </h4>
              <Button
                variant="link"
                className="ml-2"
                id="export-btn"
                onClick={handleGenerateReport}
                disabled={!data}
              >
                Generate Report
              </Button>
            </div>
            <Form.Check
              type="switch"
              id="exclude-delivery-fee-switch"
              label="Exclude Delivery Fee"
              checked={excludeDeliveryFee}
              onChange={(e) => setExcludeDeliveryFee(e.target.checked)}
            />
          </div>
        </Bargraph>
      )}
    </>
  );
};

export default SalesByFulfillmentCard;

const OrdersModal = ({ show, onHide, data }) => {
  if (!data) return null;

  return (
    <Modal show={show} onHide={onHide} centered size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Orders on {data.date}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {data.isLoading ? (
          <PacmanWrapper />
        ) : (
          <>
            <h4>Total Sales: {toPesoAmount(data.total)}</h4>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Order #</th>
                  <th>Customer</th>
                  <th>Status</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {data.orders.length > 0 ? (
                  data.orders.map((order) => (
                    <tr key={order._id}>
                      <td>
                        <Link to={`/orders/${order._id}`} target="_blank">
                          {order.transaction_number}
                        </Link>
                      </td>
                      <td>
                        {order.guest_customer?.first_name}{" "}
                        {order.guest_customer?.last_name}
                      </td>
                      <td>
                        <span
                          className={`label label-lg label-light-${getStatusDisplay(
                            order.status,
                          )} label-inline`}
                        >
                          {getStatusDisplay(order.status, order.order_type)}
                        </span>
                      </td>
                      <td>{toPesoAmount(order.total)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No orders found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};
